// =====================================================================
// Which source does a request come from — TP or TP Lite?
//
// The "TP Requests / TP Lite Requests" switch separates CLUB TIERS
// (professional vs semi-professional). That distinction only means
// something on "All Listed Requests", where a club is looking at other
// clubs' rows. Under "My Requests" a club sees its OWN requests, which
// are all of its own tier, and under "Saved" it sees its own bookmarks —
// on both there is nothing to separate, so the switch is not offered.
// (Marin: "TP Requests und Lite Requests gibt es nur bei All Listed
// Requests!!!")
//
// Two ids reach this predicate for the same tab, and that is deliberate:
// the desktop header sets "all-tenders" (components/club/responsive/
// DesktopHeader.js:194) while the mobile bar sets "all-listed-tenders"
// (components/club/responsive/MobileTenderTabs.js:96). That mismatch
// predates this change and is NOT fixed here — the two ids already send
// slightly different queries, and unifying them is a data change, not a
// layout one. Accepting both simply keeps the switch visible on the tab
// the user actually opened, on both form factors.
// =====================================================================

/** Main-tab ids that mean "All Listed Requests". */
export const ALL_LISTED_MAIN_TABS = ["all-tenders", "all-listed-tenders"];

/** The source the app falls back to wherever the switch is not offered. */
export const DEFAULT_SOURCE_TAB = "tp-tenders";

/** Is the TP / TP Lite switch meaningful on this main tab? */
export const showsSourceTabs = (activeMainTab) =>
  ALL_LISTED_MAIN_TABS.includes(activeMainTab);

/**
 * The source a QUERY should use.
 *
 * Hiding a control without pinning what it drove is how a hidden control
 * turns into a silently wrong list: pick "TP Lite" on All Listed, switch
 * to My Requests, and the club would fetch its own requests with
 * is_lite=true and see an empty tab. So wherever the switch is not shown,
 * the query reads the default source. The user's CHOICE is deliberately
 * left untouched in state, so returning to All Listed still shows the tab
 * they had picked.
 */
export const effectiveSourceTab = (activeMainTab, activeSubTab) =>
  showsSourceTabs(activeMainTab) ? activeSubTab : DEFAULT_SOURCE_TAB;
